import { useState } from 'react'
import { Typography, Layout, Row, Col, Button, Form, Input, Alert } from 'antd'

import SiteHeader from './SiteHeader'

const contactEndpoint = '/api/contact.php'

function Contact() {
    const [form] = Form.useForm()
    const [submitting, setSubmitting] = useState(false)
    const [result, setResult] = useState(null)

    async function handleSubmit(values) {
        setSubmitting(true)
        setResult(null)

        try {
            const response = await fetch(contactEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            })
            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || '提交失败，请稍后再试。')
            }

            form.resetFields()
            setResult({
                type: 'success',
                message: '提交成功，我们会尽快通过邮件与您联系。',
            })
        } catch (error) {
            setResult({
                type: 'error',
                message: error.message || '提交失败，请稍后再试。',
            })
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="sy-home">
            <SiteHeader />
            <Layout style={{'minHeight': 'calc(100vh - 71px)', 'backgroundColor': 'transparent'}}>
            <Layout.Content>
                <Row justify='center' style={{'padding': '64px 20px'}}>
                    <Col style={{'width': '100%', 'maxWidth': '760px'}}>
                        <Typography.Title level={1} style={{'color': '#1D174D', 'marginBottom': '16px'}}>
                            联系我们
                        </Typography.Title>
                        <Typography.Paragraph style={{'fontSize': '18px', 'lineHeight': 1.8, 'color': '#555'}}>
                            如果您想了解上渔App、商务合作、产品反馈或其他问题，请填写下面的表格。
                        </Typography.Paragraph>

                        <Row style={{'marginTop': '34px', 'padding': '28px', 'backgroundColor': '#f7f7fb', 'borderRadius': '8px'}}>
                            <Col style={{'width': '100%'}}>
                                {result && (
                                    <Alert
                                        type={result.type}
                                        message={result.message}
                                        showIcon
                                        style={{'marginBottom': '24px'}}
                                    />
                                )}

                                <Form form={form} layout='vertical' onFinish={handleSubmit}>
                                    <Form.Item
                                        label='姓名'
                                        name='name'
                                        rules={[
                                            { required: true, message: '请输入您的姓名' },
                                            { max: 50, message: '姓名不能超过50个字符' },
                                        ]}>
                                        <Input size='large' placeholder='请输入您的姓名' />
                                    </Form.Item>

                                    <Form.Item
                                        label='邮箱'
                                        name='email'
                                        rules={[
                                            { required: true, message: '请输入您的邮箱' },
                                            { type: 'email', message: '请输入有效的邮箱地址' },
                                            { max: 100, message: '邮箱不能超过100个字符' },
                                        ]}>
                                        <Input size='large' placeholder='name@example.com' />
                                    </Form.Item>

                                    <Form.Item
                                        label='联系方式'
                                        name='phone'
                                        rules={[
                                            { max: 50, message: '联系方式不能超过50个字符' },
                                        ]}>
                                        <Input size='large' placeholder='手机号或微信号（选填）' />
                                    </Form.Item>

                                    <Form.Item
                                        label='留言内容'
                                        name='message'
                                        rules={[
                                            { required: true, message: '请输入留言内容' },
                                            { max: 2000, message: '留言内容不能超过2000个字符' },
                                        ]}>
                                        <Input.TextArea rows={7} placeholder='请填写您想咨询的问题或合作需求' />
                                    </Form.Item>

                                    <Form.Item name='website' style={{'display': 'none'}}>
                                        <Input tabIndex={-1} autoComplete='off' />
                                    </Form.Item>

                                    <Button
                                        htmlType='submit'
                                        size='large'
                                        loading={submitting}
                                        style={{
                                            'backgroundColor': '#1D174D',
                                            'borderColor': '#1D174D',
                                            'color': '#ffffff',
                                            'fontWeight': 'bold',
                                            'borderRadius': '24px',
                                            'padding': '0 40px',
                                            'height': '48px',
                                        }}>
                                        发送留言
                                    </Button>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Layout.Content>
            </Layout>
        </div>
    )
}

export default Contact
